// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import "swiper/css/bundle";
import CarouselController from "./carousel_controller";
import HeaderMenuController from "./header_menu_controller";
import AccordionController from "./accordion_controller";
import SelectController from "./select_controller";
import YandexMapController from "./yandex_map_controller";
import SpoilerController from "./spoiler_controller";
import GalleryController from "./gallery_controller";
import StepFormController from "./step_form_controller";

application.register("header-menu", HeaderMenuController);
application.register("accordion", AccordionController);
application.register("carousel", CarouselController);
application.register("select", SelectController);
application.register("yandex-map", YandexMapController);
application.register("spoiler", SpoilerController);
application.register("gallery", GalleryController);
application.register("step-form", StepFormController);
